<template>
  <div>
    <add-beneficiary-referent
      :data-to-show="popupAddState"
      @showChange="
        (val) => {
          changeStateAddBenficiaryReferentPopup(val);
        }
      "
    />
    <edit-specific-rights
      :data-to-show="popupEditSpecifyRightState"
      @showChange="
        (val) => {
          changeStateEditSpecifyRightsBenficiaryReferentPopup(val);
        }
      "
    />
    <delete-beneficiary-referent
      :data-to-show="popupDeleteState"
      @showChange="
        (val) => {
          changeStateDeletePopup(val);
        }
      "
    />

    <h5
      v-if="
        $can(constants.PERMISSION_GESTION_DROITS_REFERENT_DROITS_SUR_NEOPASS)
      "
      class="text-left ml-5 lg:ml-15 2xl:ml-20 mt-15 text-indigo-600"
    >
      Liste des référents >
      <span class="text-gray-600"
        >Liste des bénéficiaires attribués à
        {{ referentToEdit.firstname }}
        <span class="uppercase">{{ referentToEdit.lastname }}</span></span
      >
    </h5>

    <!-- BEGIN content tab gestion des bénéficiaires par référent -->
    <div
      class=""
      v-if="
        $can(constants.PERMISSION_GESTION_DROITS_REFERENT_DROITS_SUR_NEOPASS)
      "
    >
      <!-- BEGIN add new + search + sort -->
      <div
        class="flex content-center items-center justify-between my-15 2xl:my-20 mx-5 lg:mx-15 2xl:mx-20"
      >
        <div class="flex flex-col items-center justify-center mt-5 w-full">
          <!-- BEGIN Button to add a "Beneficiary to a referent" -->

          <div class="flex items-center justify-between w-full px-5 mb-2">
            <add-button
              v-if="
                true ||
                !referentToEdit.roles.some((role) => role.type === 'admin')
              "
              libelle="Ajouter un bénéficiaire à gérer"
              responsive
              @add="displayAddBenficiaryReferentPopup()"
            />
            <!-- END Button to add a "Beneficiary to a referent" -->
            <!-- BEGIN Search engine and alphabetic order -->
            <div class="w-2/3 sm:w-1/3">
              <search-bar
                name="searchBeneficiaryToReferent"
                libelle=""
                :value="searchBeneficiary"
                placeholder="Rechercher un bénéficiaire"
                :big="false"
                :inherits="false"
                :has-border="false"
                @input="
                  (newValue) => {
                    searchBeneficiary = newValue;
                  }
                "
              />
            </div>
          </div>
          <div class="w-full px-5 flex items-center justify-end">
            <sort-button
              :sort="sort"
              @sorted="
                (sortType) => {
                  sort = sortType;
                }
              "
            />
          </div>
          <!-- END Search engine and alphabetic order -->
        </div>
      </div>
      <!-- END add new + search + sort -->

      <list-grid
        grid="grid-cols-6 md:grid-cols-12"
        :list-items="beneficiariesSort.filter((_) => !saving)"
        label-key="beneficiary"
      >
        <template
          #header
          v-if="beneficiariesSort.filter((_) => !saving).length > 0"
        >
          <div
            class="col-start-1 lg:col-start-2 col-span-2 md:col-span-5 lg:col-span-4 ml-5 md:ml-10 xl:ml-0"
          >
            Bénéficiaires
          </div>
          <div class="col-span-2 md:col-span-3">Rôles</div>
          <div class="col-span-1 md:col-span-2 truncate">
            Droits d'accès spécifiques
          </div>
          <div class="col-span-1 md:col-span-2 truncate">
            Révoquer les droits
          </div>
        </template>
        <template #accordionDescription="{ item, num }">
          <div class="col-start-1 col-span-1 hidden lg:inline">
            <ProfilePicture size="max-w-10 w-10 h-10" :other-object="item" />
          </div>
          <div
            class="col-start-1 lg:col-start-2 col-span-2 md:col-span-5 lg:col-span-4 ml-5 md:ml-10 xl:ml-0"
          >
            {{ item.firstname }}
            <span class="uppercase truncate">{{ item.lastname }}</span>
          </div>
          <div
            class="col-span-2 md:col-span-3 place-self-center justify-self-start"
          >
            <input-select
              v-if="!referentToEdit.roles.some((role) => role.type === 'admin')"
              :name="`role${item.id}`"
              :datas="listRoles"
              :value="item.role"
              @input="
                (newValue) => {
                  item.role = newValue;
                  changeBeneficiaryReferentRole(item);
                }
              "
              libelle=""
            />
            <input-select
              v-else
              :name="`role${item.id}`"
              :datas="[{ value: referentToEdit.roles[0].name }]"
              :value="referentToEdit.roles[0].name"
              libelle=""
              disabled
            />
          </div>
          <div
            class="col-span-1 md:col-span-2 place-self-center justify-self-start"
            v-if="!referentToEdit.roles.some((role) => role.type === 'admin')"
          >
            <div
              class="w-max"
              @click="displayEditSpecifyRightsBenficiaryReferentPopup(item)"
            >
              <circle-button
                v-if="item.role === 'Accès spécifiques'"
                icon="options"
                bg-color="bg-indigo-100"
                bg-color-hover="hover:bg-indigo-300"
                border-color="border-indigo-600"
                label="Modifier les droits spécifiques"
                :enable-click="false"
              />
            </div>
          </div>
          <div
            v-else
            class="col-span-1 md:col-span-2 place-self-center justify-self-start"
          />

          <div
            class="col-span-1 md:col-span-2 place-self-center justify-self-start"
          >
            <circle-button
              v-if="!referentToEdit.roles.some((role) => role.type === 'admin')"
              icon="close"
              icon-scale="75"
              label="Révoquer les droits"
              @buttonClick="displayConfirmDeletePopup(item)"
            />
          </div>
        </template>
      </list-grid>

      <div
        v-if="
          beneficiariesReferent.length > 0 && beneficiariesSort.length === 0
        "
        class="flex flex-col justify-center items-center w-full"
      >
        <h3
          class="text-pink-600 w-full text-center font-semibold text-lg mt-12"
        >
          Aucun résultat !
        </h3>
        <h4 class="text-indigo-600 w-4/6 text-center text-base mt-8 mb-16">
          Aucun bénéficiaire ne correspond à votre recherche, veuillez réessayer
          avec de nouveaux éléments
        </h4>
        <div>
          <illustration name="no_result" />
        </div>
      </div>

      <div
        class="text-gray-600 text-center w-full"
        v-if="beneficiariesReferent.length == 0"
      >
        {{ referentToEdit.firstname }}
        <span class="uppercase">{{ referentToEdit.lastname }}</span> n'a aucun
        Neopass attribué
      </div>

      <!-- BEGIN list of referents -->
      <div v-if="saving" class="w-full flex justify-center items-center">
        <div
          class="border rounded-full h-3 w-3 mr-1 sm:h-4 sm:w-4 sm:mr-1.5 border-t-2 border-r-2 border-l-0 border-b-0 border-gray-900 border-opacity-25 animate-spin"
        />
      </div>
      <!-- END list of referents -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Icon from './../../components/Icon';
import Illustration from '../../components/Illustration.vue';
import CircleButton from './../../components/CircleButton';
import InputSelect from './../../components/Inputs/InputSelect';
import SortButton from './../../components/SortButton';
import SearchBar from '../../components/Inputs/SearchBar.vue';

import AddBeneficiaryReferent from './popup/AddBeneficiaryReferent';
import EditSpecificRights from './popup/EditSpecificRights';
import DeleteBeneficiaryReferent from './popup/DeleteBeneficiaryReferent';

import Constants from './../../constants';
import ProfilePicture from './../../components/ProfilePicture.vue';
import ListGrid from '../../components/AccordionTable/ListGrid.vue';
import AddButton from '../../components/Inputs/AddButton.vue';

export default {
  name: 'BenficiariesReferents',

  components: {
    AddButton,
    ListGrid,
    ProfilePicture,
    Icon,
    Illustration,
    CircleButton,
    InputSelect,
    AddBeneficiaryReferent,
    EditSpecificRights,
    DeleteBeneficiaryReferent,
    SortButton,
    SearchBar,
  },

  data() {
    return {
      popupAddState: false,
      popupEditSpecifyRightState: false,
      popupDeleteState: '',

      searchBeneficiary: '',
      sort: 'ABC',
    };
  },

  methods: {
    ...mapMutations({
      SET_SAVING: 'permissions/SET_SAVING',
      SET_ERRORS: 'permissions/SET_ERRORS',
      SET_BENEFICIARYREFERENTTOEDIT:
        'beneficiariesReferent/SET_BENEFICIARYREFERENTTOEDIT',
      SET_SPECIFICRIGHTSTOEDIT:
        'beneficiariesReferent/SET_SPECIFICRIGHTSTOEDIT',
    }),

    ...mapActions({
      loadBeneficiaryReferentRights:
        'beneficiariesReferent/loadBeneficiaryReferentRights',
      saveBeneficiariesToReferent:
        'beneficiariesReferent/saveBeneficiariesToReferent',
    }),

    initStatus() {},

    changeStateAddBenficiaryReferentPopup(state) {
      this.popupAddState = state;
      if (!state) {
        this.initStatus();
      }
    },

    displayAddBenficiaryReferentPopup() {
      this.changeStateAddBenficiaryReferentPopup(true);
    },

    changeStateEditSpecifyRightsBenficiaryReferentPopup(state) {
      this.popupEditSpecifyRightState = state;

      if (!state) {
        this.SET_SPECIFICRIGHTSTOEDIT({});
        this.SET_BENEFICIARYREFERENTTOEDIT({});
      }
    },

    async displayEditSpecifyRightsBenficiaryReferentPopup(beneficiary) {
      await this.SET_BENEFICIARYREFERENTTOEDIT(beneficiary);
      await this.loadBeneficiaryReferentRights();

      await this.changeStateEditSpecifyRightsBenficiaryReferentPopup(true);
    },

    changeStateDeletePopup(state) {
      this.popupDeleteState = state;
      if (state == '') {
        this.initStatus();
      }
    },

    displayConfirmDeletePopup(beneficiary) {
      this.SET_BENEFICIARYREFERENTTOEDIT(beneficiary);
      this.changeStateDeletePopup('areYouSure');
    },

    changeBeneficiaryReferentRole(beneficiary) {
      this.saveBeneficiariesToReferent({
        typeSave: 'role',
        beneficiary: beneficiary,
      });
    },
  },

  computed: {
    ...mapGetters({
      listNeopassModulesPages: 'permissions/listNeopassModulesPages',
      listPermissions: 'permissions/listPermissions',
      roles: 'roles/roles',
      referents: 'referents/referents',
      beneficiaries: 'beneficiaries/beneficiaries',
      referentToEdit: 'referents/referentToEdit',
      beneficiariesReferent: 'beneficiariesReferent/beneficiariesReferent',
      beneficiariesToAdd: 'beneficiariesReferent/beneficiariesToAdd',
      beneficiaryReferentToEdit:
        'beneficiariesReferent/beneficiaryReferentToEdit',
      saving: 'permissions/saving',
    }),

    constants: function () {
      return Constants;
    },

    listRoles: function () {
      let list = [];

      this.roles
        .filter((role) => {
          return ![
            Constants.ROLE_ADMIN_PAYEUR,
            Constants.ROLE_ADMIN_ENTREPRISE,
            Constants.ROLE_BENEFICIAIRE,
          ].includes(role.name);
        })
        .forEach((role) => {
          list.push({ value: role.display_name });
        });

      list.push({ value: '_', disabled: true });
      list.push({ value: 'Accès spécifiques' });

      return list;
    },

    //Recherche Neopass
    beneficiariesFilter: {
      get: function () {
        let filteredList = [];

        filteredList = [...this.beneficiariesReferent].filter(
          (beneficiary) =>
            beneficiary.firstname
              .toLocaleLowerCase()
              .includes(this.searchBeneficiary.toLocaleLowerCase()) ||
            beneficiary.lastname
              .toLocaleLowerCase()
              .includes(this.searchBeneficiary.toLocaleLowerCase())
        );
        return filteredList;
      },
    },

    //Tri Neopass
    beneficiariesSort() {
      let sortedList = [];

      if (['ABC', 'ZYX'].includes(this.sort)) {
        sortedList = [...this.beneficiariesFilter].sort(function (a, b) {
          let nameA = a.lastname.toUpperCase();
          let nameB = b.lastname.toUpperCase();
          return nameA.localeCompare(nameB);
        });
      }

      if (['JAN', 'DEC'].includes(this.sort)) {
        sortedList = [...this.beneficiariesFilter].sort(function (a, b) {
          let dateA = a.created_at;
          let dateB = b.created_at;
          return dateA.localeCompare(dateB);
        });
      }

      if (['ABC', 'JAN'].includes(this.sort)) {
        return sortedList;
      }
      if (['ZYX', 'DEC'].includes(this.sort)) {
        return sortedList.reverse();
      }
    },
  },
};
</script>
